export default __webpack_public_path__ + "assets/images/g-content-bg6-272e3563.jpg";